/**
 * Media identity by path. Signed CloudFront URLs rotate their query string on
 * every populate, so two URLs for the same file are only equal on origin +
 * pathname. Anything that asks "is this element still pointing at the editor
 * audio / the local canvas / this rendition" must compare through here, never
 * with `===`.
 */
export function isSameMediaFile(a: unknown, b: unknown): boolean {
  if (typeof a !== 'string' || typeof b !== 'string') return false;
  try {
    const ua = new URL(a);
    const ub = new URL(b);
    return ua.origin === ub.origin && ua.pathname === ub.pathname;
  } catch {
    return a === b;
  }
}
